import { BreadcrumbModel } from "../models/breadcrumbs.model";

function breadcrumbFromHome(...crumbs: BreadcrumbModel[]): BreadcrumbModel[] {
  crumbs.unshift({ label: "Home", href: "/#/home" });
  return crumbs;
}

export default breadcrumbFromHome;
